import { Button, styled, Typography } from '@mui/material'

export const Paragraph = styled(Typography)`
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1.3;
  color: #4e5256;
  text-transform: 'lowercase';
`

export const SocialButton = styled(Button)`
  &.MuiButton-root.social-button {
    height: 48px;
    box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.08);
    padding: 12px 0;
  }
`
